import { useEffect } from 'react';
import qs from 'query-string';
import { LogoTriangle } from '@stratumn/atomic';

import { deepGet } from '@/utils';
import { env } from '@/constant/env';
import { Button } from '@/shadcn/button';
import { TestId } from '@/types/testId';
import { LogoStratumn } from '@/components/ui/customIcons/logoStratumn';

export const Login = (props: any) => {
  useEffect(() => {
    // clear the cookie when we try loggin in
    document.cookie =
      'local_stratumn_account=; expires=Thu, 01 Jan 1970 00:00:01 GMT;stratumn_account=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.title = 'Log in - Trace';
  }, []);

  const getRedirectUri = () => {
    const redirect = deepGet(props, 'location.state.redirect');
    return `${window.location.origin}${redirect || ''}`;
  };

  const onLoginClick = () => {
    const params = qs.stringify({
      clientId: env.VITE_CLIENT_ID,
      redirectUri: getRedirectUri()
    });
    window.location.replace(`${env.VITE_ACCOUNT_URL}/login?${params}`);
  };

  return (
    <>
      <div
        className="bg-primary-dark dark:bg-background fixed inset-0 -z-1 h-full bg-[url('/src/assets/IndigoTrace_Map.svg')] bg-cover bg-center bg-no-repeat dark:brightness-50"
        role="none"
      />
      <div className="flex min-h-screen flex-col items-center justify-between">
        <div className="flex flex-col items-center">
          <div className="mt-[60px] flex h-9 items-center justify-center overflow-hidden">
            <LogoStratumn fillWhite className="h-full" axis="y" />
          </div>
          <div className="text-primary-foreground mt-11 font-semibold">
            The new backbone to business collaboration
          </div>
          <div className="bg-card border-border mt-5 flex w-full max-w-[400px] flex-col items-center rounded-md border px-[60px] py-[20px]">
            <div className="mb-5 font-semibold">
              Sign in with Stratumn Account
            </div>
            <Button
              onClick={onLoginClick}
              data-testid={TestId.Login.Button}
              aria-label="Click to login"
            >
              <LogoTriangle fillWhite size={13} />
              Sign in
            </Button>
          </div>
        </div>
        <div
          className="text-contrast mb-2.5 text-center text-xs"
          aria-label="Built by Stratumn"
        >
          Built by{' '}
          <a
            href="https://stratumn.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-inherit hover:underline"
          >
            Stratumn
          </a>
        </div>
      </div>
    </>
  );
};
